import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewSv = () => {
    return <AnonymousView languageCode="sv" />
}

export default AnonymousViewSv
